import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { base, baseSepolia, foundry } from "wagmi/chains";
import { http } from "viem";

const wcProjectId = import.meta.env.VITE_WC_PROJECT_ID || "DEMO_PROJECT_ID";
const rpcUrl = import.meta.env.VITE_RPC_URL || "https://sepolia.base.org";
const chainId = Number(import.meta.env.VITE_CHAIN_ID ?? 84532);

export const wagmiConfig = getDefaultConfig({
  appName: "$FANZ Presale",
  projectId: wcProjectId,
  chains: chainId === 31337 ? [foundry, baseSepolia, base] : [baseSepolia, base],
  transports: {
    [foundry.id]: http(rpcUrl),
    [baseSepolia.id]: http(rpcUrl),
    [base.id]: http("https://mainnet.base.org"),
  },
  ssr: false,
});
